export const apiConstants = {
    // ============================================================================
    // AUTHENTICATION ENDPOINTS (FastAPI Compatible)
    // ============================================================================
    ADMIN_LOGIN: '/auth/login',
    LOGOUT: '/auth/logout',
    REFRESH_TOKEN: '/auth/refresh',
    CHANGE_PASSWORD: '/auth/change-password',
    FORGOT_PASSWORD: '/auth/forgot-password',
    RESET_PASSWORD: '/auth/reset-password',
    VERIFY_EMAIL: '/auth/verify-email',
    VALIDATE_TOKEN: '/auth/validate-token',
    GET_SESSION: '/auth/session',
    
    // Legacy SMS verification (may need to be implemented in FastAPI)
    SMS_VERIFICATION: '/auth/sms-verification',
    VERIFY_FORGOT_PASSWORD_OTP: '/auth/verify-forgot-password-otp',
    
    // ============================================================================
    // USER MANAGEMENT ENDPOINTS (FastAPI Compatible)
    // ============================================================================
    GET_STAFF_DETAILS: '/users/staff-details',
    GET_STAFF_LIST: '/users',
    ADD_STAFF: '/users/staff',
    UPDATE_STAFF: '/users/staff',
    UPDATE_STAFF_STATUS: '/users/update-staff-status',
    GET_STAFF_ACTIVITY_LOGS: '/users/staff-activity-logs',
    UPDATE_FCM_TOKEN: '/users/update-fcm-token',
    GET_USER_PROFILE: '/users/profile',
    
    // ============================================================================
    // PATIENT MANAGEMENT ENDPOINTS (FastAPI Compatible)
    // ============================================================================
    GET_PATIENT_LIST: '/patients/',
    ADD_PATIENT: '/patients/pre-register',
    GET_PATIENT_DETAILS: '/patients/getPatientDetails',
    PATIENT_SEARCH: '/patients/search',
    PATIENT_UPDATE_STATUS: '/patients/update-status',
    CURRENT_STATUS: '/patients/currentStatus',
    CURRENT_LOCATION_STATUS: '/patients/currentLocationStatus',
    GET_PATIENT_RECORD_DASHBOARD: '/patients/getPatientRecordDashboard',
    
    // Legacy patient endpoints (may need mapping)
    GET_ALL_PATIENTS_CREDENTIALS: '/patients/getAllPatientsCredentials',
    UPDATE_PATIENT_CREDENTIALS: '/patients/updatePatientCredentials',
    
    // ============================================================================
    // RBAC ENDPOINTS (FastAPI Compatible)
    // ============================================================================
    GET_ALL_ROLES: '/rbac/roles',
    GET_USER_GROUP: '/rbac/getUserGroup',
    GET_USER_GROUP_LIST: '/rbac/getUserGroupList',
    ADD_USER_GROUP: '/rbac/addUserGroup',
    GET_USER_GROUP_BY_ID: '/rbac/getUserGroupById',
    UPDATE_USER_GROUP: '/rbac/updateUserGroup',
    UPDATE_GROUPS_PERMISSION: '/rbac/updateGroupsPermission',
    
    // ============================================================================
    // DYNAMIC FORMS ENDPOINTS (FastAPI Compatible)
    // ============================================================================
    
    // Department Management
    GET_DEPARTMENTS: '/dynamic-forms/departments',
    GET_DEPARTMENT_BY_ID: '/dynamic-forms/departments',
    ADD_DEPARTMENT: '/dynamic-forms/departments',
    UPDATE_DEPARTMENT: '/dynamic-forms/departments',
    DELETE_DEPARTMENT: '/dynamic-forms/departments',
    
    // Category Management
    GET_CATEGORIES: '/dynamic-forms/categories',
    GET_CATEGORY_BY_ID: '/dynamic-forms/categories',
    ADD_CATEGORY: '/dynamic-forms/categories',
    UPDATE_CATEGORY: '/dynamic-forms/categories',
    DELETE_CATEGORY: '/dynamic-forms/categories',
    
    // Form Management
    GET_FORMS: '/dynamic-forms/forms',
    GET_FORM_BY_ID: '/dynamic-forms/forms',
    GET_FORM_DETAILS: '/dynamic-forms/forms/details',
    ADD_FORM: '/dynamic-forms/forms',
    UPDATE_FORM: '/dynamic-forms/forms',
    DELETE_FORM: '/dynamic-forms/forms',
    SUBMIT_FORM: '/dynamic-forms/forms/submit',
    VALIDATE_FORM: '/dynamic-forms/forms/validate',
    
    // Form Submissions
    GET_SUBMISSIONS: '/dynamic-forms/submissions',
    GET_SUBMISSION_BY_ID: '/dynamic-forms/submissions',
    GET_FORM_DATA_LIST: '/dynamic-forms/submissions',
    GET_FORM_DATA_LIST_BY_STAFF: '/dynamic-forms/submissions/by-staff',
    GET_FORM_DATA_LIST_DETAIL_BY_ID: '/dynamic-forms/submissions/detail-by-id',
    
    // Analytics
    GET_SUBMISSION_STATS: '/dynamic-forms/analytics/submission-stats',
    GET_FORM_SUBMISSION_COUNTS: '/dynamic-forms/analytics/form-submission-counts',
    GET_MONTHLY_STATS: '/dynamic-forms/analytics/monthly-stats',
    GET_PATIENT_SUBMISSION_SUMMARY: '/dynamic-forms/analytics/patient',
    
    // ============================================================================
    // MEDICATIONS ENDPOINTS (FastAPI Compatible)
    // ============================================================================
    GET_PRESCRIPTION_LIST: '/medications/prescriptions/list',
    GET_PRESCRIPTION_ASSIGN_LIST: '/medications/prescriptions/assign-list',
    UPDATE_RX_STATUS: '/medications/prescriptions/update-status',
    INITIATE_DRUG: '/medications/prescriptions/initiate',
    RECORD_DRUG: '/medications/prescriptions/record',
    GET_DRUG_HISTORY: '/medications/prescriptions/history',
    INSERT_RX_DATA: '/medications/prescriptions/rx-data',
    GET_MEDPASS_PRESCRIPTION_LIST: '/medications/getMedpassPrescriptionList',
    
    // ============================================================================
    // MASTER DATA ENDPOINTS (FastAPI Compatible)
    // ============================================================================
    GET_MASTER_LIST: '/master-data/tables',
    SAVE_MASTER_DATA: '/master-data/save',
    GET_MASTER_TABLE_DATA: '/master-data/table-data',
    DELETE_MASTER_DATA: '/master-data/delete',
    UPDATE_MASTER_TABLE: '/master-data/update-table',
    IMPORT_EXCEL_FILE: '/master-data/import-excel',
    GET_MASTER_DATA_DETAILS: '/master-data/details',
    
    // CPT Master
    GET_CPT_MASTER_LIST: '/master-data/cpt-master',
    ADD_CPT_MASTER: '/master-data/cpt-master',
    DELETE_CPT_MASTER_DATA: '/master-data/cpt-master/delete',
    
    // Drug Master
    GET_DRUG_MASTER_LIST: '/master-data/drug-master',
    
    // HCPCS Master
    GET_HCPCS_MASTER_LIST: '/master-data/hcpcs-master',
    ADD_HCPCS_MASTER: '/master-data/hcpcs-master',
    DELETE_HCPCS_MASTER_DATA: '/master-data/hcpcs-master/delete',
    
    // ICD Master
    GET_ICD_MASTER_LIST: '/master-data/icd10-master',
    ADD_ICD_MASTER: '/master-data/icd10-master',
    DELETE_ICD_MASTER_DATA: '/master-data/icd10-master/delete',
    
    // ============================================================================
    // SCHEDULING ENDPOINTS (FastAPI Compatible)
    // ============================================================================
    
    // Employee Management
    CREATE_EMPLOYEE: '/scheduling/employees',
    GET_EMPLOYEES: '/scheduling/employees',
    GET_EMPLOYEE_BY_ID: '/scheduling/employees',
    UPDATE_EMPLOYEE: '/scheduling/employees',
    
    // Schedule Management
    CREATE_SCHEDULE: '/scheduling/schedules',
    GET_SCHEDULES: '/scheduling/schedules',
    GET_SCHEDULE_BY_ID: '/scheduling/schedules',
    UPDATE_SCHEDULE: '/scheduling/schedules',
    CLOCK_IN: '/scheduling/schedules/clock-in',
    CLOCK_OUT: '/scheduling/schedules/clock-out',
    
    // Appointment Management
    CREATE_APPOINTMENT: '/scheduling/appointments',
    GET_APPOINTMENTS: '/scheduling/appointments',
    GET_APPOINTMENT_BY_ID: '/scheduling/appointments',
    UPDATE_APPOINTMENT: '/scheduling/appointments',
    UPDATE_APPOINTMENT_STATUS: '/scheduling/appointments/status',
    
    // Provider Schedule Management
    CREATE_PROVIDER_SCHEDULE: '/scheduling/provider-schedules',
    GET_PROVIDER_SCHEDULES: '/scheduling/provider-schedules',
    GET_PROVIDER_SCHEDULE_BY_ID: '/scheduling/provider-schedules',
    
    // Analytics and Metrics
    GET_WORKFORCE_METRICS: '/scheduling/analytics/workforce',
    GET_SCHEDULING_METRICS: '/scheduling/analytics/scheduling',
    GET_DASHBOARD_METRICS: '/scheduling/analytics/dashboard',
    
    // Utility Methods
    CHECK_SCHEDULE_CONFLICTS: '/scheduling/schedules/check-conflicts',
    SEARCH_AVAILABILITY: '/scheduling/availability/search',
    
    // Legacy Endpoints (deprecated - will be removed)
    GET_UPCOMING_EVENT: '/scheduling/upcoming-events',
    GET_DOCTOR_LIST: '/scheduling/doctors',
    ADD_DOCTOR_APPOINTMENT: '/scheduling/appointments',
    GET_APPOINTMENT_LIST: '/scheduling/appointments/list',
    GET_APPOINTMENTS_BY_DOC_ID: '/scheduling/appointments/by-doctor',
    UPDATE_APPOINTMENTS_BY_ID: '/scheduling/appointments/update',
    DELETE_APPOINTMENTS_BY_ID: '/scheduling/appointments/delete',
    
    // ============================================================================
    // DASHBOARD ENDPOINTS (FastAPI Compatible)
    // ============================================================================
    GET_DASHBOARD_STATISTICS: '/dashboard/statistics',
    GET_FORM_MENU: '/dashboard/form-menu',
    GET_FORM_DATA_LIST_DASHBOARD: '/dashboard/form-data-list',
    
    // ============================================================================
    // NOTIFICATION ENDPOINTS (FastAPI Compatible)
    // ============================================================================
    GET_NOTIFICATIONS_LIST: '/notifications',
    GET_NOTIFICATION_BY_ID: '/notifications',
    SEND_NOTIFICATION: '/notifications/send',
    CREATE_NOTIFICATION: '/notifications/create',
    MARK_NOTIFICATION_READ: '/notifications/mark-read',
    MARK_ALL_NOTIFICATIONS_READ: '/notifications/mark-all-read',
    ACKNOWLEDGE_NOTIFICATION: '/notifications/acknowledge',
    DELETE_NOTIFICATION: '/notifications/delete',
    GET_NOTIFICATION_TEMPLATES: '/notifications/templates',
    GET_NOTIFICATION_PREFERENCES: '/notifications/preferences',
    UPDATE_NOTIFICATION_PREFERENCES: '/notifications/preferences',
    
    // ============================================================================
    // DOCUMENT MANAGEMENT ENDPOINTS (FastAPI Compatible)
    // ============================================================================
    UPLOAD_DOCUMENT: '/documents/upload',
    GET_DOCUMENT: '/documents/get',
    DELETE_DOCUMENT: '/documents/delete',
    GET_DOCUMENT_LIST: '/documents/list',
    
    // ============================================================================
    // AUDIT AND LOGGING ENDPOINTS (FastAPI Compatible)
    // ============================================================================
    GET_LOG_HISTORY: '/audit/log-history',
    GET_FORM_LOG_HISTORY: '/dynamic-forms/form-log-history',
    
    // ============================================================================
    // REPORTS ENDPOINTS (FastAPI Compatible)
    // ============================================================================
    GET_ALL_REPORT_CONTENT: '/reports/all-content',
    UPDATE_REPORT_CONTENT: '/reports/update-content',
    ADD_REPORTS: '/reports/add',
    GET_REPORTS: '/reports/get',
    
    // ============================================================================
    // LEGACY ENDPOINTS (For backward compatibility during transition)
    // ============================================================================
    
    // Legacy form endpoints (will be removed after migration)
    GET_FORM_LIST: '/dynamic-forms/forms',
    UPDATE_FORMS_PERMISSION: '/dynamic-forms/updateFormsPermission',
    GET_FORM_LIST_FOR_STAFF: '/dynamic-forms/forms',
    GET_FORM_LIST_FOR_MENU: '/dynamic-forms/forms',
    SAVE_WEB_FORM: '/dynamic-forms/forms',
    UPDATE_WEB_FORM: '/dynamic-forms/forms/update',
    DELETE_WEB_FORM: '/dynamic-forms/forms/delete',
    ADD_WEB_FORM_FIELDS: '/dynamic-forms/forms/add-fields',
    DELETE_WEB_FORM_FIELD: '/dynamic-forms/forms/delete-field',
    SUBMIT_WEB_FORM: '/dynamic-forms/forms/submit-web-form',
    
    // Legacy form submissions
    GET_PIVOTED_FORM_DATA: '/dynamic-forms/submissions/pivoted',
    INSERT_FORM_DATA: '/dynamic-forms/forms/submit',
    UPDATE_SUB_FORM_DATA: '/dynamic-forms/submissions/update-sub-form',
    RE_ADMIT_DATA: '/dynamic-forms/forms/re-admit',
    UPDATE_ADDENDUM_STATUS: '/dynamic-forms/submissions/update-addendum-status',
    
    // Legacy form categories and fields
    GET_CATEGORY_LIST: '/dynamic-forms/categories',
    GET_CATEGORY_LIST_FOR_WEB_FORM: '/dynamic-forms/categories',
    GET_FORM_CATEGORY: '/dynamic-forms/getFormCategory',
    GET_FIELD_TYPE_LIST: '/dynamic-forms/field-types',
    GET_FORM_TYPE_LIST: '/dynamic-forms/form-types',
    GET_FORM_FIELDS_DATA: '/dynamic-forms/forms/fields-data',
    
    // Legacy department management
    GET_DEPARTMENT_LIST: '/dynamic-forms/departments',
    GET_DEPARTMENT_DETAILS: '/dynamic-forms/getDepartmentDetails',
    GET_DEPARTMENT_FORMS_LIST: '/dynamic-forms/departments',
    ADD_DEPARTMENT_FORMS: '/dynamic-forms/addDepartmentForms',
    GET_DEPARTMENT_FORM_DETAILS: '/dynamic-forms/getDepartmentFormDetails',
    UPDATE_DEPARTMENT_FORM: '/dynamic-forms/updateDepartmentForm',
    GET_DEPARTMENT_MENUES: '/dynamic-forms/getDepartmentMenues',
    
    // Legacy master data
    GET_MASTER_LIST_DETAIL_BY_NAME: '/master-data/detail-by-name',
    GET_MASTER_TABLE_COLUMN: '/master-data/table-columns',
    ADD_MASTER_DATA_DETAILS: '/master-data/add-details',
    DELETE_TABLE_DATA: '/master-data/delete-table-data',
    GET_TABLE_CONTENT_DETAIL_BY_ID: '/master-data/table-content-by-id',
    UPDATE_TABLE_CONTENT_DETAILS_BY_ID: '/master-data/update-table-content',
    DELETE_MASTER_COLUMN: '/master-data/delete-column',
    UPDATE_MASTER_TABLE_FIELDS: '/master-data/update-table-fields',
    
    // Legacy notifications
    UPDATE_NOTIFICATION: '/updateNotification',
    DELETE_NOTIFICATION_LEGACY: '/deleteNotification',
    ADD_REPORT_REASON: '/addReportReason',
    GETFORMLOGHISTORY: '/getFormLogHistory'
};

// Helper function to get endpoint by category
export const getEndpointsByCategory = (category) => {
    const categoryMap = {
        auth: Object.keys(apiConstants).filter(key => key.includes('LOGIN') || key.includes('AUTH') || key.includes('TOKEN') || key.includes('PASSWORD')),
        users: Object.keys(apiConstants).filter(key => key.includes('USER') || key.includes('STAFF')),
        patients: Object.keys(apiConstants).filter(key => key.includes('PATIENT')),
        forms: Object.keys(apiConstants).filter(key => key.includes('FORM') || key.includes('SUBMISSION')),
        medications: Object.keys(apiConstants).filter(key => key.includes('MEDICATION') || key.includes('PRESCRIPTION') || key.includes('DRUG')),
        scheduling: Object.keys(apiConstants).filter(key => key.includes('APPOINTMENT') || key.includes('SCHEDULE')),
        dashboard: Object.keys(apiConstants).filter(key => key.includes('DASHBOARD')),
        reports: Object.keys(apiConstants).filter(key => key.includes('REPORT')),
        audit: Object.keys(apiConstants).filter(key => key.includes('LOG') || key.includes('AUDIT'))
    };
    
    return categoryMap[category] || [];
};

// Export default for backward compatibility
export default apiConstants;